<script setup lang="ts">
const queryClient = useQueryClient();
await queryClient.ensureQueryData(productsQueryOptions({ slugs: ['bil'] }));
const { getBySlug } = useProducts({ slugs: ['bil'] });
const product = computed(() => getBySlug('bil'));
useSeo({ title: computed(() => product.value?.heading?.value ?? '') });

useSchemaOrg([
  defineBreadcrumb({
    itemListElement: [
      { name: 'Forside', item: '/' },
      { name: 'Kørekort', item: '/kørekort' },
      { name: computed(() => product.value?.heading?.value ?? 'Bil') },
    ],
  }),
  defineCourse({
    name: computed(() => product.value?.heading?.value ?? ''),
    description: computed(() => product.value?.description?.value ? stripHtml(product.value.description.value) : ''),
    inLanguage: 'da',
    provider: { '@id': '#identity' },
  }),
]);
</script>

<template>
  <ProductContainer
    v-if="product"
    :product="product.product"
  >
    <template #illustration>
      <IconsCategoryBil />
    </template>
    <LazyVisibleSignupForm
      course-type="bil"
      hydrate-on-visible
    />
  </ProductContainer>
</template>
